import { render, staticRenderFns } from "./HomeKpiGrid.vue?vue&type=template&id=cd965242&scoped=true&"
import script from "./HomeKpiGrid.vue?vue&type=script&lang=js&"
export * from "./HomeKpiGrid.vue?vue&type=script&lang=js&"
import style0 from "./HomeKpiGrid.vue?vue&type=style&index=0&id=cd965242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd965242",
  null
  
)

export default component.exports